/* KŌSMOPELLIS — interactions premium légères */
(function () {
  'use strict';

  // Révélation au défilement
  function initReveal() {
    var els = document.querySelectorAll('.kp-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('kp-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('kp-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el, i) {
      el.style.transitionDelay = (Math.min(i % 4, 3) * 80) + 'ms';
      io.observe(el);
    });
  }

  // Filet de sécurité : tout révéler après 1,5s
  function safety() {
    setTimeout(function () {
      document.querySelectorAll('.kp-reveal:not(.kp-in)').forEach(function (el) {
        el.classList.add('kp-in');
      });
    }, 1500);
  }

  function init() { initReveal(); safety(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Ré-init dans l'éditeur de thème
  document.addEventListener('shopify:section:load', initReveal);
})();

/* Barre livraison offerte — maj client-side sur tout changement de panier
   PERF 90 / correctif 18/10 : Dawn déclare PUB_SUB_EVENTS avec « const » (constants.js) → ce n'est PAS une propriété de window.
   L'ancien test window.PUB_SUB_EVENTS était donc toujours faux : la barre ne se mettait jamais à jour sur /cart après suppression
   (constaté : 214,60 € → 36,80 €, « livraison offerte » restait affiché). On lit désormais la constante globale.
   La barre met aussi à jour son icône (camion / coche), sa progression accessible, et se masque quand le panier est vide. */
(function () {
  var SVG_OPEN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var ICO_TRUCK = SVG_OPEN + '<path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>';
  var ICO_CHECK = SVG_OPEN + '<path d="M20 6L9 17l-5-5"/></svg>';
  function events() { return (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS; }
  function setHtml(el, html) { if (el && el.innerHTML !== html) el.innerHTML = html; }
  function fmtEur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function update(total) {
    document.querySelectorAll('[data-kp-shipbar]').forEach(function(bar){ updateBar(bar, total); });
  }
  function updateBar(bar, total) {
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 5900;
    var pct = Math.min(100, Math.round((total * 100) / threshold));
    var fill = bar.querySelector('.kp-shipbar__fill');
    var msg = bar.querySelector('.kp-shipbar__msg');
    var txt = bar.querySelector('.kp-shipbar__txt');
    var ico = bar.querySelector('.kp-shipbar__ico');
    var track = bar.querySelector('.kp-shipbar__track');
    bar.hidden = total <= 0;
    if (fill) fill.style.width = pct + '%';
    if (track) track.setAttribute('aria-valuenow', pct);
    if (total >= threshold) {
      bar.classList.add('is-done');
      if (msg) msg.classList.add('kp-shipbar__msg--done');
      if (ico && ico.getAttribute('data-kp-state') !== 'done') { ico.innerHTML = ICO_CHECK; ico.setAttribute('data-kp-state', 'done'); }
      setHtml(txt, 'Félicitations ! La <strong>livraison est offerte</strong>.');
    } else {
      bar.classList.remove('is-done');
      if (msg) msg.classList.remove('kp-shipbar__msg--done');
      if (ico && ico.getAttribute('data-kp-state') !== 'todo') { ico.innerHTML = ICO_TRUCK; ico.setAttribute('data-kp-state', 'todo'); }
      setHtml(txt, 'Plus que <strong>' + fmtEur(threshold - total) + '</strong> pour la <strong>livraison offerte</strong> !');
    }
  }
  function refresh() {
    fetch((window.routes ? window.routes.cart_url : '/cart') + '.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && typeof c.total_price === 'number') update(c.total_price); })
      .catch(function () {});
  }
  window.kpShipbarRefresh = refresh;
  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 300); }
  document.addEventListener('DOMContentLoaded', function () {
    var ev = events();
    if (typeof subscribe === 'function' && ev && ev.cartUpdate) {
      subscribe(ev.cartUpdate, schedule);
    }
    // Filet : Dawn ne publie pas cartUpdate quand la suppression du DERNIER article lève une erreur de rendu (panier vide) ;
    // on suit donc aussi les changements du contenu du panier (page /cart et tiroir). La barre est hors de ces zones : pas de boucle.
    if ('MutationObserver' in window && document.querySelector('[data-kp-shipbar]')) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t && t.closest && t.closest('cart-items, cart-drawer-items')) { schedule(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  });
})();

/* Upsell panier — ajout d'un produit suggéré + re-render du drawer */
(function () {
  function addUpsell(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    // 19/10 : un seul ajout en vol par bouton (double clic sur réseau lent = deux articles sinon).
    if (btn.getAttribute('aria-busy') === 'true' || btn.disabled) return;
    var drawer = document.querySelector('cart-drawer');
    var sections = (drawer && typeof drawer.getSectionsToRender === 'function')
      ? drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      : 'cart-drawer,cart-icon-bubble';
    btn.setAttribute('aria-busy', 'true');
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { btn.removeAttribute('aria-busy'); return; }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        }
        var ev = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS; // correctif 18/10 : constante Dawn « const », absente de window
        if (typeof publish === 'function' && ev && ev.cartUpdate) {
          publish(ev.cartUpdate, { source: 'kp-cart-upsell', productVariantId: variantId, cartData: data });
        }
      })
      .catch(function () { btn.removeAttribute('aria-busy'); })
      .then(function () { if (btn.isConnected) btn.removeAttribute('aria-busy'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-kp-upsell-add]') : null;
    if (btn) { e.preventDefault(); addUpsell(btn); }
  });
})();
